(function () {
  "use strict";

  const consentBox = document.querySelector(".comment-form-cookies-consent");
  if (consentBox) {
    consentBox.classList.add("ns-checkbox");
  }

  function exLikes() {
    document.querySelectorAll(".comment-like-btn").forEach(function (btn) {
      let id = btn.getAttribute("data-id");
      let cookie_name = "comment_like_btn";
      let cookie = window.getCookie(cookie_name);
      if (cookie === "") {
        cookie = [];
      } else {
        cookie = JSON.parse(cookie);
      }
      let rate_exists = cookie.indexOf(id);
      if (rate_exists >= 0) {
        btn.classList.add("disabled");
      }
    });
  }

  document.addEventListener("click", function (e) {
    const likeBtn = e.target.closest(".comment-like-btn");
    if (likeBtn) {
      let cookie_name = "comment_like_btn";
      let cookie = window.getCookie(cookie_name);
      if (cookie === "") {
        cookie = [];
      } else {
        cookie = JSON.parse(cookie);
      }
      let rate_exists = cookie.indexOf(likeBtn.getAttribute("data-id"));
      if (rate_exists === -1) {
        if (cookie.length === 0) {
          cookie[0] = likeBtn.getAttribute("data-id");
          cookie = JSON.stringify(cookie);
          window.setCookie(cookie_name, cookie, 30, false);
        } else {
          cookie[cookie.length] = likeBtn.getAttribute("data-id");
          cookie = JSON.stringify(cookie);
          window.setCookie(cookie_name, cookie, 30, false);
        }
        if (!likeBtn.classList.contains("disabled")) {
          likeBtn.classList.add("disabled");

          const formData = new URLSearchParams();
          formData.append("action", "negarshop_comment_rates");
          formData.append("id", likeBtn.getAttribute("data-id"));
          formData.append("act", likeBtn.getAttribute("data-action"));

          fetch(NS_OBJ.ajax_url, {
            method: "POST",
            body: formData,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          })
            .then((res) => res.json())
            .then((response) => {
              if (response.status) {
                const countEl = likeBtn.querySelector(".count");
                if (countEl) countEl.textContent = response.data;
                exLikes();
              }
              document
                .querySelectorAll(
                  '.comment-like-btn[data-id="' +
                    likeBtn.getAttribute("data-id") +
                    '"]',
                )
                .forEach((btn) => {
                  btn.classList.add("disabled");
                });
            })
            .catch((err) => console.error(err));
        }
      } else {
        likeBtn.classList.add("disabled");
      }
      return;
    }

    const answerTrigger = e.target.closest(
      ".product-questions .answer-action .answer-modal-trigger",
    );
    if (answerTrigger) {
      e.preventDefault();
      const parentId = answerTrigger.getAttribute("data-parent");
      const modalEl = document.getElementById("product-qa-answer-modal");

      if (modalEl && typeof bootstrap !== "undefined" && bootstrap.Modal) {
        const form = modalEl.querySelector("form");
        if (!form) {
          const accountWidget = document.querySelector(".header-account");
          const isPopupEnabled = accountWidget && accountWidget.classList.contains("pop-up-login");
          if (isPopupEnabled) {
            const loginModalEl = document.getElementById("login-popup-modal");
            if (loginModalEl) {
              const loginModal = bootstrap.Modal.getOrCreateInstance(loginModalEl);
              loginModal.show();
            }
          } else {
            const accountLink = document.querySelector(".header-account .box-inner");
            window.location.href = accountLink ? accountLink.getAttribute("href") : "/my-account/";
          }
          return;
        }

        const parentInput = form.querySelector('[name="comment_parent"]');
        if (parentInput) {
          parentInput.value = parentId;
        }

        const textarea = form.querySelector('textarea[name="comment"]');
        if (textarea) {
          textarea.value = "";
        }

        const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
        modal.show();
      }
      return;
    }

    const commentTabLink = e.target.closest(".comment-tabs .tabs a");
    if (commentTabLink) {
      e.preventDefault();
      if (
        !commentTabLink.classList.contains("disabled") &&
        !commentTabLink.classList.contains("active")
      ) {
        commentTabLink.classList.add("disabled");
        const listWrapper = document.querySelector(".comment-list-wrapper");
        if (listWrapper) listWrapper.classList.add("loading");

        const formData = new URLSearchParams();
        formData.append("action", "negarshop_comment_tabs");
        formData.append("id", commentTabLink.getAttribute("data-id"));
        formData.append("order", commentTabLink.getAttribute("data-order"));

        fetch(NS_OBJ.ajax_url, {
          method: "POST",
          body: formData,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              const listEl = document.querySelector(
                ".comment-list-wrapper .comments-list",
              );
              if (listEl) listEl.innerHTML = response.data;
              document
                .querySelectorAll(".comment-tabs .tabs a")
                .forEach((a) => a.classList.remove("active"));
              commentTabLink.classList.add("active");
              exLikes();
            }
            if (listWrapper) listWrapper.classList.remove("loading");
            commentTabLink.classList.remove("disabled");
          })
          .catch((err) => {
            console.error(err);
            if (listWrapper) listWrapper.classList.remove("loading");
            commentTabLink.classList.remove("disabled");
          });
      }
      return;
    }
  });

  const initMultiStepReviewModal = () => {
    const modalEl = document.getElementById("product-add-review-modal");
    if (!modalEl) return;

    const form = modalEl.querySelector("#commentform");
    if (!form || form.classList.contains("multi-step-init")) return;

    form.classList.add("multi-step-init");

    // Detect steps elements
    const hasSliders = form.querySelector(".comment-form-slider") !== null;
    const hasRating = form.querySelector(".comment-form-rating") !== null;
    const step1HasContent = hasSliders || hasRating;

    const steps = [];
    if (step1HasContent) {
      steps.push({ id: 1, title: NS_OBJ.i18n.step_rating || "امتیازدهی" });
    }
    steps.push({ id: 2, title: NS_OBJ.i18n.step_comment || "متن دیدگاه" });
    steps.push({ id: 3, title: NS_OBJ.i18n.step_pros_cons || "نقاط قوت و ضعف" });

    const formSubmit = form.querySelector(".form-submit");
    if (!formSubmit) return;

    // Create steps wrapper divs
    const step1Div = document.createElement("div");
    step1Div.className = "review-form-step review-form-step-1";
    form.querySelectorAll(".comment-form-slider, .comment-form-rating").forEach(el => step1Div.appendChild(el));

    const step2Div = document.createElement("div");
    step2Div.className = "review-form-step review-form-step-2";
    form.querySelectorAll(".comment-form-comment, .comment-form-author, .comment-form-email, .comment-form-cookies-consent").forEach(el => step2Div.appendChild(el));

    const step3Div = document.createElement("div");
    step3Div.className = "review-form-step review-form-step-3";
    
    // Find the row containing .plus-cfc and .negative-chips
    const chipsRow = form.querySelector(".plus-cfc")?.closest(".row") || form.querySelector(".negative-chips")?.closest(".row");
    if (chipsRow) {
      step3Div.appendChild(chipsRow);
    } else {
      form.querySelectorAll(".plus-cfc, .negative-chips, .comment-form-chip").forEach(el => step3Div.appendChild(el));
    }
    
    const attachments = form.querySelector("#comment-attachments");
    if (attachments) {
      step3Div.appendChild(attachments);
    }

    // Insert steps divs before formSubmit
    if (step1HasContent) {
      form.insertBefore(step1Div, formSubmit);
    }
    form.insertBefore(step2Div, formSubmit);
    form.insertBefore(step3Div, formSubmit);

    // Create stepper indicator
    const stepperContainer = document.createElement("div");
    stepperContainer.className = "review-steps-stepper mb-4";

    steps.forEach((step, idx) => {
      const stepItem = document.createElement("div");
      stepItem.className = `step-item step-item-${step.id}${idx === 0 ? " active" : ""}`;
      stepItem.setAttribute("data-step-id", step.id);

      const stepIcon = document.createElement("span");
      stepIcon.className = "step-icon";
      stepIcon.textContent = idx + 1;
      stepItem.appendChild(stepIcon);

      const stepTitle = document.createElement("span");
      stepTitle.className = "step-title";
      stepTitle.textContent = step.title;
      stepItem.appendChild(stepTitle);

      stepperContainer.appendChild(stepItem);
    });

    // Insert stepperContainer at the top of the form
    form.insertBefore(stepperContainer, form.firstChild);

    // Create Next / Prev buttons
    const prevBtn = document.createElement("button");
    prevBtn.type = "button";
    prevBtn.className = "button button--secondary button-prev-step d-none";
    prevBtn.textContent = NS_OBJ.i18n.prev_step || "مرحله قبل";

    const nextBtn = document.createElement("button");
    nextBtn.type = "button";
    nextBtn.className = "button button--primary button-next-step";
    nextBtn.textContent = NS_OBJ.i18n.next_step || "مرحله بعد";

    const submitBtn = formSubmit.querySelector("#submit");

    formSubmit.prepend(prevBtn);
    formSubmit.insertBefore(nextBtn, submitBtn);

    let currentStepIdx = 0;

    const validateStep = (stepId) => {
      if (stepId === 1) {
        const ratingSelect = form.querySelector("select#rating");
        if (ratingSelect && ratingSelect.hasAttribute("required") && !ratingSelect.value) {
          alert(NS_OBJ.i18n.rating_required || "لطفا امتیاز خود را انتخاب کنید.");
          ratingSelect.focus();
          return false;
        }
      } else if (stepId === 2) {
        const commentTextarea = form.querySelector("textarea#comment");
        if (commentTextarea && commentTextarea.hasAttribute("required") && !commentTextarea.value.trim()) {
          alert(NS_OBJ.i18n.comment_required || "لطفا متن دیدگاه خود را بنویسید.");
          commentTextarea.focus();
          return false;
        }
        const authorInput = form.querySelector("input#author");
        if (authorInput && authorInput.hasAttribute("required") && !authorInput.value.trim()) {
          alert(NS_OBJ.i18n.name_required || "لطفا نام خود را بنویسید.");
          authorInput.focus();
          return false;
        }
        const emailInput = form.querySelector("input#email");
        if (emailInput) {
          const emailVal = emailInput.value.trim();
          if (emailInput.hasAttribute("required") && !emailVal) {
            alert(NS_OBJ.i18n.email_required || "لطفا ایمیل خود را بنویسید.");
            emailInput.focus();
            return false;
          }
          if (emailVal) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(emailVal)) {
              alert(NS_OBJ.i18n.email_invalid || "لطفا یک ایمیل معتبر وارد کنید.");
              emailInput.focus();
              return false;
            }
          }
        }
      }
      return true;
    };

    const goToStep = (idx) => {
      currentStepIdx = idx;
      const activeStep = steps[currentStepIdx];

      form.querySelectorAll(".review-form-step").forEach(stepDiv => {
        stepDiv.classList.remove("active");
      });
      const targetStepDiv = form.querySelector(`.review-form-step-${activeStep.id}`);
      if (targetStepDiv) {
        targetStepDiv.classList.add("active");
      }

      stepperContainer.querySelectorAll(".step-item").forEach((stepItem, sIdx) => {
        stepItem.classList.remove("active", "completed");
        if (sIdx < currentStepIdx) {
          stepItem.classList.add("completed");
        } else if (sIdx === currentStepIdx) {
          stepItem.classList.add("active");
        }
      });

      if (currentStepIdx === 0) {
        prevBtn.classList.add("d-none");
      } else {
        prevBtn.classList.remove("d-none");
      }

      if (currentStepIdx === steps.length - 1) {
        nextBtn.classList.add("d-none");
        if (submitBtn) submitBtn.classList.remove("d-none");
      } else {
        nextBtn.classList.remove("d-none");
        if (submitBtn) submitBtn.classList.add("d-none");
      }
    };

    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const activeStep = steps[currentStepIdx];
      if (validateStep(activeStep.id)) {
        goToStep(currentStepIdx + 1);
      }
    });

    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      goToStep(currentStepIdx - 1);
    });

    form.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        const target = e.target;
        if (
          target.tagName.toLowerCase() === "textarea" ||
          target.type === "submit" ||
          target.type === "button"
        ) {
          return;
        }

        if (target.closest(".chips-input input.text-field")) {
          return;
        }

        e.preventDefault();

        if (currentStepIdx < steps.length - 1) {
          const activeStep = steps[currentStepIdx];
          if (validateStep(activeStep.id)) {
            goToStep(currentStepIdx + 1);
          }
        } else {
          if (submitBtn) {
            submitBtn.click();
          }
        }
      }
    });

    modalEl.addEventListener("hidden.bs.modal", function () {
      goToStep(0);
    });

    goToStep(0);
  };

  const init = () => {
    initMultiStepReviewModal();

    const firstTab = document.querySelector(
      ".comment-tabs .tabs li:first-of-type a",
    );
    if (firstTab) {
      firstTab.click();
    }

    const answerModalEl = document.getElementById("product-qa-answer-modal");
    if (answerModalEl) {
      answerModalEl.addEventListener("hidden.bs.modal", function () {
        const form = answerModalEl.querySelector("form");
        if (form) {
          const parentInput = form.querySelector('[name="comment_parent"]');
          if (parentInput) {
            parentInput.value = "0";
          }
          const textarea = form.querySelector('textarea[name="comment"]');
          if (textarea) {
            textarea.value = "";
          }
        }
      });
    }

    if (
      typeof Dropzone !== "undefined" &&
      document.getElementById("comment-attachments")
    ) {
      Dropzone.autoDiscover = false;
      let commentAttachments = [];
      let myDropzone = new Dropzone("#comment-attachments", {
        url: NS_OBJ.ajax_url,
        maxFilesize: 2,
        maxFiles: 5,
        acceptedFiles: "image/png,image/jpg,image/jpeg",
        dictDefaultMessage: NS_OBJ.i18n.dropzone_s1,
        dictFileTooBig: NS_OBJ.i18n.dropzone_s2,
        dictInvalidFileType: NS_OBJ.i18n.dropzone_s3,
      });

      myDropzone.on("sending", function (file, xhr, formData) {
        formData.append("action", "negarshop_comment_attachments");
        formData.append("nonce", NSDP.nonce);
      });
      myDropzone.on("processing", function () {
        const submitBtn = document.querySelector("#commentform #submit");
        if (submitBtn) submitBtn.classList.add("disabled");
      });
      myDropzone.on("queuecomplete", function () {
        const submitBtn = document.querySelector("#commentform #submit");
        if (submitBtn) submitBtn.classList.remove("disabled");
      });
      myDropzone.on("success", function (file) {
        let response = JSON.parse(file.xhr.response);
        if (typeof response.success !== "undefined") {
          if (response.success) {
            commentAttachments.push(response.attach);
            const attachIds = document.getElementById("comment-attach-ids");
            if (attachIds) attachIds.value = commentAttachments.join(",");
          } else {
            alert(response.data?.message ?? NS_OBJ.i18n.an_error);
          }
        }
      });
    }

    if (window.jQuery && typeof window.jQuery.fn.lightGallery === "function") {
      window.jQuery(".comment-attachments").lightGallery({
        selector: "a",
      });
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
